import React from 'react';

import { HeaderBar } from '../../../shared/components/header-components/HeaderBar/HeaderBar';
import { SOLUTION_TYPE } from '../../../shared/constants/user-info/solutionType';
import { HeaderLogo } from '../../../shared/components/header-components/HeaderLogo/HeaderLogo';

const ChallengesHeader = () => {
  return (
    <HeaderBar
      toolbarComponent="div"
      inAngularContainer
      solution={SOLUTION_TYPE.CHALLENGE}
    >
      <HeaderLogo solution={SOLUTION_TYPE.CHALLENGE} />
    </HeaderBar>
  );
};

export { ChallengesHeader };
